import $ from 'jquery';
import { $Win } from '../utils/jQueryGlobals';
import { Fancybox } from '@fancyapps/ui';

export default class Context {
  /**
   * Il costruttore ora separa la logica in due parti:
   * 1. initOnce(): Funzionalità globali da eseguire una sola volta.
   * 2. initComponentsAndPageLogic(): Funzionalità legate al contenuto, da rieseguire ad ogni cambio pagina.
   */
  constructor() {
    this.initOnce();
    this.initComponentsAndPageLogic();
  }


  initOnce() {
    document.documentElement.classList.remove('no-js');
    this.initMouseCoords();
    this.initScrollEvent();
  }


  initComponentsAndPageLogic() {
    this.loadComponents();

    $(() => {
      
      $('.rte table').wrap('<div class="responsive-table" />');
      Fancybox.bind('[data-fancybox="gallery"]', {
      });

      $('[data-fancybox-jump-to]').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt($(e.currentTarget).data('fancybox-jump-to'));
        Fancybox.getInstance()?.jumpTo(index);
        return false;
      });
    });
  }

  /**
   * Metodo pubblico chiamato da App.js sull'hook 'content:replace' di Swup.
   * Si occupa di preparare e reinizializzare la nuova pagina.
   */
  reinit() {
  
    Fancybox.close();
    this.initComponentsAndPageLogic();
  }

  /**
   * Metodo pubblico chiamato da App.js sull'hook 'page:leave' di Swup.
   * Fondamentale per "pulire" le animazioni GSAP (specialmente ScrollTrigger)
   * prima che i loro elementi target vengano rimossi dal DOM, prevenendo memory leak e bug.
   */
  cleanupGSAP() {
    // Trova tutte le istanze di ScrollTrigger e le "uccide" in modo pulito.
    if (window.ScrollTrigger) {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }
    
    // Se hai animazioni GSAP globali non legate a ScrollTrigger che potrebbero
    // continuare a girare, puoi terminarle qui. Esempio:
    // gsap.killTweensOf('.elemento-con-animazione-persistente');
  }


  /**
   * Aggiunge un event listener ottimizzato usando requestAnimationFrame
   * per evitare di sovraccaricare il browser.
   */
  addEventListenerFrame(event, callback) {
    let timeout;
    if (typeof event == 'string') {
      event = [event];
    }
    event.forEach((ev) => {
      window.addEventListener(ev, (e) => {
        if (timeout) {
          window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(() => callback(e));
      });
    });
  }

  initScrollEvent() {
    this.addEventListenerFrame(['scroll', 'resize'], () => {
      $Win.trigger('efficient-scroll', document.documentElement.scrollTop);
    });
    $Win.trigger('efficient-scroll', document.documentElement.scrollTop);
  }

  initMouseCoords() {
    this.addEventListenerFrame('mousemove', (e) => {
      document.documentElement.style.setProperty('--mouse-client-x', `${e.clientX}px`);
      document.documentElement.style.setProperty('--mouse-client-y', `${e.clientY}px`);
    });
  }

  /**
   * Carica dinamicamente i componenti presenti nel DOM.
   * La funzione è asincrona per attendere il caricamento dei moduli JS.
   */
  async loadComponents(name = false, context) {
    const selector = name
      ? `[data-g-component="${name}"]`
      : '[data-g-component]';

    const elementsToInitialize = $(selector, context).get().filter(elem => !$(elem).data('g-component-initialized'));

    // Esegue tutte le richieste di import in parallelo
    await Promise.all(elementsToInitialize.map(async (elem) => {
      const $elem = $(elem);
      const componentName = $elem.data('g-component');

      if (componentName) {
        try {
          // --- IMPORT DINAMICO ---
          const module = await import(`../components/${componentName}.js`);
          const ComponentClass = module.default;

          if (typeof ComponentClass === 'function') {
            new ComponentClass(elem, this);
            $elem.data('g-component-initialized', true);
          } else {
            console.error(`Il componente "${componentName}" è stato caricato ma non è una classe/funzione valida.`);
          }
        } catch (error) {
          console.error(`Errore durante il caricamento del componente "${componentName}":`, error);
        }
      }
    }));
  }
  
  getCssVar(name, elem = document.documentElement) {
    return getComputedStyle(elem).getPropertyValue(name);
  }

  getBreakpoint(bp, elem = document.documentElement) {
    let value = this.getCssVar(`--breakpoint-${bp}`, elem);
    if (value) {
      value = parseInt(value);
    }
    return value || 0;
  }
}
